//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class LanguageDisplayItem extends ItemBase {
    ID: string | null = null;
    Code: string | null = null;
    DisplayName: string | null = null;
    NativeName: string | null = null;
    EnglishName: string | null = null;

    constructor(initializer?: Partial<LanguageDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "LanguageDisplayItem";
}
